import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ScaleContainer = styled.div`
  width: ${pxToRem(1920)};
  height: ${pxToRem(1080)};
  transform-origin: top left;
  --scale: calc(100vw / 1920);
  transform: scale(var(--scale));
`;

export const ProfilePageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  /*
    Без этого карточка не сжимается уже своего содержимого:
    у flex-элемента min-width по умолчанию auto. На окне 1024
    таблица лидов вылезала за экран на 370 пикселей вместе
    с колонкой действий, и доскроллить было нельзя — body глушит
    горизонтальную прокрутку. Теперь карточка сжимается,
    а прокрутку берёт на себя контейнер таблицы.
  */
  min-width: 0;
  flex: 1;
  margin-left: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${pxToRem(32)} ${pxToRem(24)};
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.ink};
`;

export const TemplateList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${pxToRem(12)};
`;

export const TemplateItem = styled.div``;

export const ButtonWrapper = styled.div`
  margin-top: ${pxToRem(22)};
  display: flex;
  align-items: center;
  justify-content: end;
  gap: ${pxToRem(16)};
  width: 450px;
`;
